import { useEffect } from 'react';
// Radix Presence owns mount timing through exit animations. Callback refs
// detach and reattach while closed state settles, so they report too early.
export function ContentMountSignal({ onMountChange, }) {
    useEffect(() => {
        onMountChange(true);
        return () => onMountChange(false);
    }, [onMountChange]);
    return null;
}
//# sourceMappingURL=ContentMountSignal.js.map